import React, { Component } from "react";
import styles from "./filterAndSearchTools.module.scss";
import { withLogosticFilter } from "../../../shared/containers/containerLogosticFilter";
import Icon from "../../../shared/items/static/icon";
import InputMask from "react-input-mask";
import { withLogisticControlPoints } from "../../../shared/containers/containerLogisticControlPoints";
import { withLogisticGroups } from "../../../shared/containers/containerLogisticGroups";
import FilterLogisticGroupsTools from "./FilterLogisticGroupsTools";

let searchTimeOutId = null;

class FilterAndSearchTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: "",
      logisticGroups: [],
    };
  }

  componentDidMount() {
    const { onFilter, onGetlogisiticGroups, searchTerm, logisticGroupsFilter } = this.props;

    onFilter({
      orderBy: "title",
      searchTerm,
      logisticGroups: logisticGroupsFilter.map((x) => {
        return x.id;
      }),
    });

    onGetlogisiticGroups();
  }

  onChangeSearchTerm(e) {
    const { onFilter, onLogisticSearchTerm, logisticGroupsFilter } = this.props;

    clearTimeout(searchTimeOutId);
    this.setState({ searchTerm: e.target.value });
    onLogisticSearchTerm(e.target.value);

    searchTimeOutId = setTimeout(() => {
      onFilter({
        searchTerm: e.target.value,
        logisticGroups: logisticGroupsFilter.map((x) => {
          return x.id;
        }),
      });
    }, 600);
  }

  render() {
    const { searchTerm } = this.state;
    const { onFilter, titleSearch = "Поиск по контрольным точкам" } = this.props;

    return (
      <div className={styles.filterContainer}>
        <div className={styles.filterAndSearchToolsContainer}>
          <div className={styles.inputStyle}>
            <InputMask type={"text"} placeholder={titleSearch} onChange={this.onChangeSearchTerm.bind(this)} value={searchTerm} />
          </div>

          <div className={styles.container_searchBtn}>
            <Icon name="search" />
          </div>
        </div>
        <FilterLogisticGroupsTools onFilter={onFilter} />
      </div>
    );
  }
}

export default withLogisticGroups(withLogisticControlPoints(withLogosticFilter(React.memo(FilterAndSearchTools))));
